<template>
    <button type="button" @click="executeAsyncAction" :disabled="isExecutingAction" class="btn px-5" :class="classes">
        {{ text }}
    </button>
</template>

<script setup lang="ts">
import { ref, defineProps, PropType, watch, inject, Ref, computed } from 'vue';

const props = defineProps({
    text: { type: String, required: true },
    asyncAction: {
        type: Function as PropType<() => Promise<any>>,
        required: true,
    },
    classes: {type: String, required: false, default: 'btn-primary' }
});

const isExecutingAction = ref(false);
const execute = inject<Ref<boolean>>('execute', ref(false));

watch(execute, (newVal) => {
    if (newVal) {
        executeAsyncAction();
    }
});

const executeAsyncAction = async () => {
    if (isExecutingAction.value) {
        return;
    }

    isExecutingAction.value = true;

    try {
        await props.asyncAction();
    } finally {
        isExecutingAction.value = false;
    }
};
</script>

